module.exports = __webpack_public_path__ + "img/logo-bpi-100.b4390d1d.jpg";